import { connect } from 'react-redux';
import { getChallenges, selectChallenges } from 'redux/modules/challenge';
import { selectLatestSubmissions } from 'redux/modules/challengeResponse';
import { selectUserWentBack } from 'redux/modules/router/selectors';
import { editSettings } from 'redux/modules/settings';
import { RootState } from 'redux/modules/types';

const mapStateToProps = (state: RootState) => ({
  activeChallenge: state.challenge.active,
  latestSubmissions: selectLatestSubmissions(state),
  loading: state.challenge.loading,
  pageCount: state.challenge.pageCount,
  pastChallenges: selectChallenges(state),
  wentBack: selectUserWentBack(state),
});

const mapDispatchToProps = {
  getChallenges: getChallenges.request,
  editSettings: editSettings.request,
};

export default connect(mapStateToProps, mapDispatchToProps);

export type ConnectedProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;
